// extracted by mini-css-extract-plugin
export default {"blogBanner":"Blog_blogBanner__VHeOe","bannerBg":"Blog_bannerBg__INWIW","tornPaper":"Blog_tornPaper__u42HH","bannerText":"Blog_bannerText__t693E","blogPage":"Blog_blogPage__GS-4d"};